var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 12.0833L7.91699 9.58331",
    stroke: "#DD3F1B",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.083 12.0833L12.083 9.58331",
    stroke: "#DD3F1B",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.41669H17.5V5.41669C16.6463 5.41669 16.2194 5.41669 15.8788 5.54488C15.3398 5.74775 14.9144 6.17316 14.7115 6.71219C14.5833 7.05277 14.5833 7.47963 14.5833 8.33335V12.25C14.5833 14.1356 14.5833 15.0784 13.9975 15.6642C13.4118 16.25 12.469 16.25 10.5833 16.25H9.41667C7.53105 16.25 6.58824 16.25 6.00245 15.6642C5.41667 15.0784 5.41667 14.1356 5.41667 12.25V8.33335C5.41667 7.47963 5.41667 7.05277 5.28848 6.71219C5.0856 6.17316 4.6602 5.74775 4.12117 5.54488C3.78058 5.41669 3.35372 5.41669 2.5 5.41669V5.41669Z",
    stroke: "#DD3F1B",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91634 2.91685C7.91634 2.91685 8.33301 2.08331 9.99967 2.08331C11.6663 2.08331 12.083 2.91665 12.083 2.91665",
    stroke: "#DD3F1B",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashLight);
export default __webpack_public_path__ + "static/media/Trash_light.d3421321cd29252e9d26bd83ba8561de.svg";
export { ForwardRef as ReactComponent };